export default __webpack_public_path__ + "static/media/css.01b02894.svg";